export function getPaymentRequestFromHeaders(headers, quite = false) {
    const header = headers.get("X-Cashu");
    if (!header && !quite)
        throw new Error("Missing cashu header");
    return header ? JSON.parse(atob(header)) : undefined;
}
